import { memo } from 'react';

import { isMobile } from 'hooks';
import { Drawer, DrawerHeader } from 'components/drawer';
import { EventPayments } from 'components/event-payments';

import { LocationRentDrawerProps } from './types';

export const LocationRentDrawer = memo(
  ({ opened, onClose, locationRent }: LocationRentDrawerProps) => {
    const mobile = isMobile();

    if (!locationRent?.length) {
      return null;
    }

    return (
      <Drawer hideOverlay opened={opened} topOffset={mobile ? '10%' : '15%'}>
        <DrawerHeader onClose={onClose} title="Location Rent Details" />
        <EventPayments payments={locationRent} />
      </Drawer>
    );
  }
);
